import { render, staticRenderFns } from "./ReturnList.vue?vue&type=template&id=798505b6&scoped=true"
import script from "./ReturnList.vue?vue&type=script&lang=js"
export * from "./ReturnList.vue?vue&type=script&lang=js"
import style0 from "./ReturnList.vue?vue&type=style&index=0&id=798505b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798505b6",
  null
  
)

export default component.exports